/**
 * Extracts initials from a name (up to 2 characters)
 */
export const getInitials = (name: string): string => {
  if (!name || name.trim() === '' || name.startsWith('Mentor')) {
    return "MT";
  }
  return name
    .split(' ')
    .map(word => word[0])
    .join('')
    .slice(0, 2)
    .toUpperCase();
};

/**
 * Formats price from cents to readable price string
 */
export const formatPrice = (priceCents: number | null): string => {
  if (priceCents === null) return "Consultar";
  if (priceCents === 0) return "Gratuito";
  return `R$ ${(priceCents / 100).toFixed(2).replace(".", ",")}`;
};
